import type { Config } from "auth/config/getConfig";
import { isInTestMode } from "auth/test-mode";

export async function getMSAL(config: Config) {
  if (isInTestMode()) {
    return import("./_getMsalMock").then(({ getMSAL }) => getMSAL());
  }
  return import("./_getMsal").then(({ getMSAL }) => getMSAL(config));
}
